import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Bell01, HelpCircle, LogOut01, SearchLg, Settings01 } from '@untitledui/icons';
import logo from '../../assets/logo.jpeg';
import { Avatar } from '../untitled-ui/base/avatar/avatar';
import { Button } from '../untitled-ui/base/buttons/button';
import { Input } from '../untitled-ui/base/input/input';
import { isNavigationItemActive, navigationItems } from './navigation';

interface AppLayoutProps {
  onLogout: () => void;
}

const AppLayout: React.FC<AppLayoutProps> = ({ onLogout }) => {
  const location = useLocation();

  const groups = ['Overview', 'Manage'] as const;

  return (
    <div className="app-shell">
      <aside className="app-sidebar" aria-label="Primary navigation">
        <Link to="/dashboard" className="app-brand">
          <img className="app-brand-mark" src={logo} alt="Cenadz Fitness logo" />
          <strong>Cenadz Fitness</strong>
        </Link>

        <nav className="app-sidebar-nav">
          {groups.map(group => (
            <div className="app-nav-group" key={group}>
              <span className="app-nav-label">{group}</span>
              {navigationItems.filter(item => item.group === group).map(item => {
                const Icon = item.icon;
                return (
                  <Link key={item.path} to={item.path} className={`app-nav-link ${isNavigationItemActive(location.pathname, item) ? 'active' : ''}`}>
                    <Icon aria-hidden="true" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          ))}
        </nav>

        <Link to="/dashboard" className="app-nav-link app-settings-link"><Settings01 /><span>Settings</span></Link>

        <div className="app-sidebar-footer">
          <Avatar size="md" initials="CA" status="online" />
          <div className="app-sidebar-user-copy">
            <strong>Gym administrator</strong>
            <span>admin@cenadz.com</span>
          </div>
          <Button size="sm" color="tertiary" iconLeading={LogOut01} aria-label="Log out" onPress={onLogout} />
        </div>
      </aside>

      <div className="app-main">
        <header className="app-mobile-header">
          <Link to="/dashboard" className="app-mobile-brand"><span>C</span>Cenadz Fitness</Link>
          <Button size="sm" color="secondary" iconLeading={LogOut01} onPress={onLogout}>Log out</Button>
        </header>
        <header className="app-desktop-header">
          <div className="app-header-tools">
            <Input className="app-global-search" icon={SearchLg} shortcut="⌘K" placeholder="Search members, payments..." />
            <Button size="md" color="tertiary" iconLeading={HelpCircle}>Help</Button>
            <Button className="app-notification-button" size="md" color="secondary" iconLeading={Bell01} aria-label="Notifications" />
          </div>
        </header>

        <main className="app-content">
          <Outlet />
        </main>
      </div>

      <nav className="app-mobile-nav" aria-label="Mobile navigation">
        {navigationItems.filter(item => item.mobile).map(item => {
          const Icon = item.icon;
          return (
          <Link
            key={item.path}
            to={item.path}
            className={`app-mobile-nav-link ${isNavigationItemActive(location.pathname, item) ? 'active' : ''}`}
          >
            <Icon aria-hidden="true" />
            <span>{item.label}</span>
          </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default AppLayout;
